module.exports = __webpack_public_path__ + "img/1519031219.ee07aa69.jpg";